import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=bb53c4f8"
import script from "./Schedule.vue?vue&type=script&lang=ts"
export * from "./Schedule.vue?vue&type=script&lang=ts"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=bb53c4f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports